"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRouterDom = require("react-router-dom");
var _authProvider = require("./authProvider");
var _unauth = _interopRequireDefault(require("components/common/unauth"));
var _excluded = ["component"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ProtectedRoute = function ProtectedRoute(_ref) {
  var Component = _ref.component,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_authProvider.AuthConsumer, null, function (_ref2) {
    var isAuth = _ref2.isAuth,
      userId = _ref2.userId,
      groups = _ref2.groups;
    return /*#__PURE__*/React.createElement(_reactRouterDom.Route, _extends({
      render: function render(props) {
        props.userId = userId;
        props.groups = groups;
        return isAuth ? /*#__PURE__*/React.createElement(Component, props) : /*#__PURE__*/React.createElement(_unauth["default"], null);
      }
    }, rest));
  });
};
var _default = exports["default"] = ProtectedRoute;